import { createFileRoute } from "@tanstack/react-router";

import Invoices from "@/features/company/invoices";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/belege",
)({
  component: InboxPage,
  staticData: {
    breadcrumb: ["payables.link"],
  },
});

function InboxPage() {
  return (
    <div className="flex-1 px-4 pb-4 h-full">
      <Invoices />
    </div>
  );
}
